/**
 * Shared helpers for entity active/inactive toggles (class, subject, course, etc.).
 */

export function canToggleEntityStatus(row) {
  if (!row) return false;
  const isActive =
    row.status === true ||
    row.status === "active" ||
    row.isActive === true;
  if (!isActive) return true;
  return row.canDeactivate !== false;
}

export function getEntityStatusToggleTooltip(row, entityLabel = "item") {
  if (!row) return "";
  const isActive =
    row.status === true ||
    row.status === "active" ||
    row.isActive === true;
  if (!isActive) return `Activate ${entityLabel}`;
  if (row.canDeactivate === false) {
    const blockers = Array.isArray(row.deactivationBlockers)
      ? row.deactivationBlockers
      : [];
    if (blockers.length) {
      return `Cannot deactivate: ${blockers.join("; ")}`;
    }
    return `Cannot deactivate ${entityLabel} while dependencies exist`;
  }
  return `Deactivate ${entityLabel}`;
}
